import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import find from 'lodash/find';
import get from 'lodash/get';
import FormGroup from 'components/Form/FormGroup';
import StaticText from 'components/Form/StaticText';
import App from 'modules/App';
import * as selectors from '../../../selectors';
const OrganizationIdentifier = ({ formValues })=>{
    const organizationTemplate = useSelector(selectors.organizationTemplate);
    const localizationResources = useSelector(App.selectors.localizationResources);
    const typeValue = get(formValues, [
        'values',
        'organizationIdentifier.organizationIdentifierType'
    ]);
    if (!typeValue) {
        return null;
    }
    const definition = find(organizationTemplate, {
        name: 'organizationIdentifier'
    });
    const fields = get(definition, 'fields', []);
    const typeDefinition = find(fields, {
        name: 'organizationIdentifierType'
    });
    const typeOptions = get(typeDefinition, 'options', []);
    const typeOption = find(typeOptions, {
        value: typeValue
    });
    const label = get(localizationResources, [
        typeOption.labelKey,
        'value'
    ], typeOption.labelKey);
    return /*#__PURE__*/ _jsx(FormGroup, {
        id: "organizationIdentifier.organizationIdentifierValue",
        labelMessage: label,
        formValues: formValues,
        isOneLiner: true,
        children: /*#__PURE__*/ _jsx(StaticText, {})
    });
};
export default OrganizationIdentifier;
